export enum MessageTemplateCreateMethodTypes {
    CREATE_FROM_SCRATCH = "create-from-scratch",
    USE_TEMPLATE = "use-template"
}